import { render, staticRenderFns } from "./ListUsers.vue?vue&type=template&id=3871f51a"
import script from "./ListUsers.vue?vue&type=script&lang=ts"
export * from "./ListUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports